module.exports = __webpack_public_path__ + "static/project-12b-7d7a22515e8db3c44d4e46e7d05f98fe.png";